<template>
  <div>
    <div @click="handleClick" :class="{ active: po, labels: labels }">
      <img src="/static/images/labels.png" alt="" />
    </div>
    <el-dialog
      title="请输入标签值"
      :visible.sync="dialogFormVisible"
      style="width: 100vw"
      :show-close="false"
      :modal="false"
    >
      <el-form :model="form">
        <el-input
          v-model="form.name"
          autocomplete="off"
          type="textarea"
          :autosize="{ minRows: 6, maxRows: 7 }"
          style="width: 40vw"
        ></el-input>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  <script>
import * as THREE from "three";
import {
  CSS2DRenderer,
  CSS2DObject,
} from "three/addons/renderers/CSS2DRenderer.js";
import Bus from "../../utils/bus.js";
import { mapMutations } from "vuex";
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialogFormVisible: false,
      po: false,
      renderer: null,
      form: {
        name: "未定义标签",
      },
      labels: "labels",
      raycaster: new THREE.Raycaster(),
      mouse: new THREE.Vector2(),
      selectedPoints: [],
      points: [],
      x: "",
      y: "",
      count: 1,
      labelRenderer: null,
      distanceDisplay: null,
      point: [],
      lable:false,
      labelMeshNames: []
    };
  },
  computed:{
    ...mapState(["toolLabels"]),
  },
  watch:{
    toolLabels:{
      handler(news,old){
        this.lable= news
        if(!this.lable){
          this.po=false
        }
    }
    }
  
  },
  methods: {
    ...mapMutations(["setToolDistance","setToolAngle","setToolLabels","setActiveModelName"]),
    cancel() {
      this.dialogFormVisible = !this.dialogFormVisible;
      this.po = !this.po;
      this.form.name = "未定义标签";
      let lang = this.points.length - 1;
      let point = this.points[lang];

      this.renderer[2].remove(point);
      this.points.splice(this.points.indexOf(point), 1);
    },
    add() {
      this.dialogFormVisible = false;
      this.po = !this.po;
      this.distanceDisplay = document.createElement("div");
      this.distanceDisplay.innerText = `${this.form.name}`;
      this.distanceDisplay.id = `${this.count++}`;
      this.distanceDisplay.style.pointerEvents = "auto";
      this.distanceDisplay.style.zIndex = "0"; // 设置 z-index 值

      this.distanceDisplay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
      this.distanceDisplay.style.borderRadius = "116px";
      this.distanceDisplay.style.color = "yellow";
      this.distanceDisplay.style.fontSize = "10px";
      const earthLabel = new CSS2DObject(this.distanceDisplay);
      earthLabel.position.set(1.5, 0, 0);
      // earthLabel.center.set(0, 1);

      this.points[this.points.length - 1].add(earthLabel);
      this.distanceDisplay.addEventListener("click", (event) => {
        const ids = event.target.id - 1;
        const meshName = this.labelMeshNames[ids]
        if (meshName) { this.setActiveModelName(meshName) }
        const points1 = this.point[0][ids];
        Bus.$emit("eventDIV", [event, points1]);
      });

      this.form.name = "未定义标签";
      const animate = () => {
        this.renderer[0].render(this.renderer[2], this.renderer[1]);

        this.labelRenderer.render(this.renderer[2], this.renderer[1]);

        requestAnimationFrame(animate);
      };
      animate();
    },
    handleClick() {
      this.setToolAngle(false)
      this.setToolDistance(false)

      this.setToolLabels(true)
      const canvasContainer = this.renderer[0].domElement;
      this.po = !this.po;
      if (this.po) {
        canvasContainer.style.cursor = "crosshair";
          this.addEventListeners();
      } else {
        canvasContainer.style.cursor = "auto";

        /*  */
      }
    },

    addEventListeners() {
      // if( !this.$store.state.addEventListenersBool[2])  return
     
      this.renderer[0].domElement.addEventListener("click", this.onMouseClick);
    },

    onMouseClick(event) {
      if (!this.po) return;
      if(!this.lable)   return
    
      const canvasContainer = this.renderer[0].domElement;
      const rect = canvasContainer.getBoundingClientRect();
      this.mouse.x =
        ((event.clientX - rect.left) / canvasContainer.clientWidth) * 2 - 1;
      this.mouse.y =
        -((event.clientY - rect.top) / canvasContainer.clientHeight) * 2 + 1;
      // 遍历场景中的所有点，查找与鼠标位置最近的点
      this.raycaster.setFromCamera(this.mouse, this.renderer[1]);
      const intersects = this.raycaster.intersectObjects(
        this.$store.state.meshList,
        true
      );
      if (intersects.length > 0) {
        const point = intersects[0].point;
        this.labelMeshNames.push(intersects[0].object.name || '')
        const material = new THREE.MeshBasicMaterial({ color: "yellow" });
        const geometry = new THREE.SphereGeometry(2);
        const sphere = new THREE.Mesh(geometry, material);
        sphere.position.copy(point);
        this.renderer[2].add(sphere);
        this.points.push(sphere);
        this.selectedPoints.push(point);
        let vector = new THREE.Vector3(point.x, point.y, point.z);
        vector.project(this.renderer[1]);
        let x = ((vector.x + 1) * window.innerWidth) / 2;
        let y = (-(vector.y - 1) * window.innerHeight) / 2;
        this.x = x;
        this.y = y;
        if (this.selectedPoints.length == 1) {
          //  获取点击位置
          this.point.push(this.points);
          this.dialogFormVisible = !this.dialogFormVisible;
          this.po = !this.po;
          this.selectedPoints = [];
        }
      }
    },
  },
  mounted() {
    this.renderer = this.$store.state.rendererRef;
    this.labelRenderer = this.$store.state.labelRenderer;

  
  },
};
</script>
  <style  lang="scss">
.labels {
  width: 35px;
  height: 35px;
  > img {
    width: 100%;
    height: 100%;
  }
}
.el-dialog {
  height: 42% !important;
  width: 70% !important;
  margin-top: 28vh !important;
  z-index: 9999 !important;
}
.el-textarea{
    width: 60vw !important;
}
.el-dialog__wrapper{
    z-index: 99999 !important;
}
.el-dialog__body{
    padding: 0 !important;
}
</style>